import React from 'react';
import {Link} from "react-router-dom";

const NewTabLink = ({children,...others}) => {
    return <Link {...others} target={'_blank'}>{children}</Link>
};

export default NewTabLink;